import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDCartAddressListResponse, IHDCartAddressListResponseData } from "@/api_framework/api_modals/Cart";
import { setAddressList } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
export const useAddressListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (
      userId: string,
      oldAddressId?: string,
      newAddressId?: string,
      clinicId?: string,
      showSuccessToast?: boolean,
    ): Promise<IHDCartAddressListResponseData[] | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IHDCartAddressListResponse> = await axios.get(
          `${CART_MODULE?.USER_ADDRESS_LIST?.baseURL}${userId}/?old_address_id=${oldAddressId}&new_address_id=${newAddressId}&clinic_id=${clinicId}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data.status === true) {
          dispatch(setAddressList({ data: res.data.data }));
          if (showSuccessToast && res.data.message) {
            // toast.success(res.data.message);
          }
          return res.data.data;
        } else {
          dispatch(setAddressList({ data: [] }));
          return [];
        }
      } catch (e: any) {
        if (axios.isAxiosError(e) && e.config) {
          sendCurl(e.config["curlCommand"]);
        }
        // captureError(e);
        // toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch, configuration, captureError, sendCurl],
  );
  return execute;
};
